export default __webpack_public_path__ + "static/media/onboarding_filetypedropdown.cfa7f3a8.jpeg";